import React from "react";
import SEO from "../../shared/components/atoms/seo/seo";
import Layout from "../../shared/components/organisms/layout/layout";
import { siteUrl } from '../../shared/utils/siteUrl';
import FilterContent from "../organisms/filter-content/filter-content";

// import SEO from "../shared/components/atoms/seo/seo"

const FilterTemplate = props => {
    // var url = typeof window !== "undefined" ? window.location.href : '';
      
    return (
        <Layout activeMenu={1}>
            <SEO
                title={props.pageContext.params.metaTitulo}
                description={props.pageContext.params.metaDescripcion.metaDescripcion}
                url={siteUrl + '/productos/' + props.pageContext.slug}
            />
            <FilterContent params={props.pageContext.params} products={props.pageContext.products} guideline={props.pageContext.guideline} filters={props.pageContext.filters} />
        </Layout>
    )
}

export default FilterTemplate